import { isNumber } from '@ahha/utils/@types/typeChecks'

export const hexToRgba = (hex: string, alpha?: number) => {
  const chunkSize = Math.floor((hex.length - 1) / 3)
  const hexArr = getChunksFromString(hex.slice(1), chunkSize)

  if (!hexArr) {
    throw new Error('Invalid HEX string.')
  }
  const [r, g, b, a] = hexArr.map(convertHexUnitTo256)

  return [r, g, b, getAlphaValue(a, alpha)]
}

const getChunksFromString = (s: string, chunkSize: number) => s.match(new RegExp(`.{${chunkSize}}`, 'g'))

const convertHexUnitTo256 = (hexStr: string) => parseInt(hexStr.repeat(2 / hexStr.length), 16)

const getAlphaValue = (a: number, alpha?: number) => {
  if (typeof a !== 'undefined') {
    return a / 255
  }
  if (!isNumber(alpha) || alpha < 0 || alpha > 1) {
    return 1
  }
  return alpha
}
